import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 线上的
    $url: "https://ejan.hzau.edu.cn/api",
    weather: {}
  },
  mutations: {
    weather(state, weather) {
      state.weather = weather;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js